<app-notification-host></app-notification-host>

@if (!authState.isResolved()) {
  <main class="app-public-content" data-testid="auth-pending"></main>
} @else if (isAuthenticated()) {
  <div class="app-layout">
    <ecab-sidebar
      [collapsed]="sidebarCollapsed"
      (collapsedChange)="sidebarCollapsed = $event"
      appName="LinkEcab"
      appSubtitle="Back Office"
      logoIcon="dashboard">

      <ecab-nav-group label="Messagerie" [collapsed]="sidebarCollapsed">
        <ecab-nav-item
          label="Messages"
          icon="mail"
          route="/messages"
          [collapsed]="sidebarCollapsed"
          [active]="isParentRouteActive('/messages')"
          (itemClick)="navigate('/messages')">
        </ecab-nav-item>
        @if (!sidebarCollapsed && messageSidebarFilters().length > 0) {
          <div class="sidebar-submenu" data-testid="messages-submenu">
            @for (filter of messageSidebarFilters(); track filter.identifier) {
              <ecab-nav-item
                class="sidebar-submenu-item"
                [label]="filter.name ?? ''"
                [collapsed]="false"
                [active]="isSidebarFilterActive(filter)"
                (itemClick)="navigateToPredefinedFilter(filter)">
              </ecab-nav-item>
            }
          </div>
        }
        <ecab-nav-item
          label="Messages ouverts"
          icon="mark_email_unread"
          route="/open-messages"
          [collapsed]="sidebarCollapsed"
          [active]="isParentRouteActive('/open-messages')"
          (itemClick)="navigate('/open-messages')">
        </ecab-nav-item>
        @if (!sidebarCollapsed && openMessageSidebarFilters().length > 0) {
          <div class="sidebar-submenu" data-testid="open-messages-submenu">
            @for (filter of openMessageSidebarFilters(); track filter.identifier) {
              <ecab-nav-item
                class="sidebar-submenu-item"
                [label]="filter.name ?? ''"
                [collapsed]="false"
                [active]="isSidebarFilterActive(filter)"
                (itemClick)="navigateToPredefinedFilter(filter)">
              </ecab-nav-item>
            }
          </div>
        }
      </ecab-nav-group>

      <div ecab-sidebar-footer>
        <ecab-user-menu
          [userName]="userName"
          [userEmail]="userEmail"
          [roles]="[{name: 'Admin', color: 'primary'}]"
          [collapsed]="sidebarCollapsed"
          (logout)="logout()">
        </ecab-user-menu>
      </div>
    </ecab-sidebar>

    <main class="app-main-content">
      <div class="app-page-container">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
} @else {
  <main class="app-public-content">
    <router-outlet></router-outlet>
  </main>
}
